var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#01FF85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6186 7.94287L16.9641 9.3085L11.4125 14.7777C11.0416 15.1486 10.5538 15.3335 10.0641 15.3335C9.57439 15.3335 9.08181 15.1467 8.7071 14.7729L6.04102 12.1892L7.37597 10.8121L10.0526 13.4063L15.6186 7.94287Z",
    fill: "#030E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.794cf032b441d068a5d2880a9feb22f2.svg";
export { ForwardRef as ReactComponent };